import React from 'react';
import { FiBookOpen } from "react-icons/fi"

const GuidelineModalToggleButton = ({ onClick, buttonText = "Guidelines" }) => {
  return (
    <button onClick={onClick} 
    className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 gap-1.5 h-9 rounded-md px-3 border border-input bg-background hover:bg-accent hover:text-accent-foreground cursor-not-allowed"
    disabled
    >
    
    <FiBookOpen className="w-4 h-4" />
      {buttonText}
    </button>
  );
};

export default GuidelineModalToggleButton;
